import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FuseWidgetModule } from '@fuse/components/widget/widget.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { BarChartModule as NgxBarChartModule } from '@swimlane/ngx-charts';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { VerticalBarChartComponent } from './vertical-bar.component';


@NgModule({
  declarations: [
    VerticalBarChartComponent
  ],
  imports: [
    NgxBarChartModule,
    FlexLayoutModule,
    FuseSharedModule,
    FuseWidgetModule,
    NgxSkeletonLoaderModule,
    TranslateModule
  ],
  exports: [
    VerticalBarChartComponent
  ]
})
export class VerticalBarChartModule {}
